import {Option, Select} from "@deere/fuel-react";
import {FormControl, InputLabel} from "@mui/material";
const createDropdownOptions = (options) => {
    const allDropDownOption = (
        <Option key="All" value="All" selected>
            All
        </Option>
    );
    let dropdownOptions = [allDropDownOption];
    if (
        options &&
        options.length > 0 &&
        !options[0]?.hasOwnProperty("dealer_branch") &&
        !options[0]?.hasOwnProperty("dealership_name") &&
        !options[0]?.hasOwnProperty("sales_person_name")
    ) {
        dropdownOptions.push(
            ...options.map((item, index) => {
                return (
                    <Option key={options[index]} value={options[index]}>
                        {options[index]}
                    </Option>
                );
            })
        );
        return dropdownOptions;
    } else if (options && options[0]?.hasOwnProperty("dealer_branch")) {
        dropdownOptions.push(
            options.map((item) => {
                return (
                    <Option key={item?.dealer_account_id} value={item?.dealer_account_id}>
                        {item?.dealer_branch + ", (" + item?.dealer_account_id + ")"}
                    </Option>
                );
            })
        );
        return dropdownOptions;
    } else if (options && options[0]?.hasOwnProperty("dealership_name")) {
        dropdownOptions.push(
            ...options.map((item, index) => {
                return (
                    <Option
                        key={options[index]?.parent_dealer_account_id}
                        value={options[index]?.parent_dealer_account_id}
                    >
                        {options[index]?.dealership_name +
                        " (" +
                        options[index]?.parent_dealer_account_id +
                        ")"}
                    </Option>
                );
            })
        );
        return dropdownOptions;
    } else if (options && options[0]?.hasOwnProperty("sales_person_name")) {
        dropdownOptions.push(
            ...options.map((item, index) => {
                return (
                    <Option
                        key={options[index]?.sales_person_id}
                        value={options[index]?.sales_person_id}
                    >
                        {options[index]?.sales_person_name +
                        " (" +
                        options[index]?.sales_person_id +
                        ")"}
                    </Option>
                );
            })
        );
        return dropdownOptions;
    }
};

const Dropdown = (props) => {
    return (
        <FormControl fullWidth>
            <InputLabel
                htmlFor="Films"
                id="Films-label"
            >
                {props.label}
            </InputLabel>
        <Select
            fullWidth={true}
            id={props.id}
            value={props.value}
            defaultValue={"All"}
            disabled={props.isDisable}
            MenuProps={{ PaperProps: { sx: { maxHeight: 250 } } }}
            onChange={props.onChangeFn}
        >
            {createDropdownOptions(props.data)}
        </Select>
        </FormControl>
    );
};

export default Dropdown;